<mat-toolbar>
  <span>
    <img
      *ngIf="clientInfo?.logo"
      class="client-logo"
      [src]="'data:image/png;base64,' + clientInfo?.logo"
      [alt]="clientInfo?.name"
      [@slideDownAppear]
    />
    <img
      *ngIf="!clientInfo?.logo"
      class="client-logo"
      src="../../../assets/images/scw-logo.png"
      alt="SCW.AI"
      [@slideDownDisappear]
    />
  </span>
  <span>
    <a routerLink="/">
      <img class="logo" src="../../../assets/images/digital-boards-logo.png" alt="Digital Boards" />
    </a>
  </span>
  <button
    mat-icon-button
    class="refresh-button"
    [attr.aria-label]="'toolbar.refresh' | translate"
    [matTooltip]="'toolbar.refresh' | translate"
    (click)="refresh()"
  >
    <mat-icon class="text-white">refresh</mat-icon>
  </button>
  <span class="spacer"></span>

  <button mat-icon-button [matMenuTriggerFor]="mobileMenu" class="d-md-none">
    <mat-icon class="text-white">menu</mat-icon>
  </button>

  <div class="d-none d-md-flex">
    <button mat-button routerLink="/dashboards" class="mx-2">{{ 'toolbar.home' | translate }}</button>
    <button *ngIf="isToolAdmin" mat-button [matMenuTriggerFor]="settingsMenu" class="mx-2">
      <div class="d-flex justify-content-center align-items-center">
        {{ 'toolbar.settings' | translate }}
        <span class="d-flex justify-content-center align-items-center"><mat-icon>keyboard_arrow_down</mat-icon></span>
      </div>
    </button>

    <button mat-button [matMenuTriggerFor]="userMenu">
      <div class="d-flex justify-content-center align-items-center">
        <mat-icon>account_circle</mat-icon>
        <span class="d-flex justify-content-center align-items-center"><mat-icon>keyboard_arrow_down</mat-icon></span>
      </div>
    </button>
    <button mat-button [matMenuTriggerFor]="scwAppSwitcher" (click)="$event.stopPropagation()">
      <div class="d-flex justify-content-center align-items-center">
        <mat-icon>apps</mat-icon>
      </div>
    </button>
  </div>
</mat-toolbar>

<mat-menu #mobileMenu="matMenu">
  <button mat-menu-item routerLink="/dashboards">{{ 'toolbar.home' | translate }}</button>

  <button *ngIf="isToolAdmin" mat-menu-item [matMenuTriggerFor]="settingsMenu">
    {{ 'toolbar.settings' | translate }}
  </button>
  <button mat-menu-item [matMenuTriggerFor]="userMenu">
    <mat-icon>person</mat-icon>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="scwAppSwitcher" (click)="$event.stopPropagation()">
    <mat-icon>apps</mat-icon>
  </button>
</mat-menu>

<mat-menu class="mt-2" #userMenu="matMenu">
  <div mat-menu-item (click)="$event.stopPropagation()">
    <app-theme-switcher></app-theme-switcher>
  </div>
  <button mat-menu-item (click)="logout()">{{ 'button.logout' | translate }}</button>
  <div class="menu-info" (click)="$event.stopPropagation()"></div>
  <mat-divider />
  <div class="menu-info" (click)="$event.stopPropagation()">
    <div class="logged-in-user">{{ fullName }}</div>
  </div>
  <mat-divider />
  <div class="menu-info" (click)="$event.stopPropagation()">
    <div>{{ 'toolbar.version' | translate }}: {{ version }}</div>
  </div>
</mat-menu>

<mat-menu class="mt-2" #scwAppSwitcher="matMenu">
  <ng-template matMenuContent>
    <scw-app-switcher />
  </ng-template>
</mat-menu>

<mat-menu class="mt-2" #settingsMenu="matMenu">
  @if (isToolAdmin) {
    <button mat-menu-item routerLink="/settings/users">
      {{ 'toolbar.usersAndTeams' | translate }}
    </button>

    @if (workspaceModules()?.digitalForms) {
      <button mat-menu-item routerLink="/settings/forms">
        {{ 'toolbar.forms' | translate }}
      </button>
      <button mat-menu-item routerLink="/settings/form-submissions">
        {{ 'toolbar.formSubmissions' | translate }}
      </button>
    }

    <button mat-menu-item routerLink="/settings/data-integrations">
      {{ 'toolbar.dataIntegrations' | translate }}
    </button>
    <button mat-menu-item routerLink="/settings/filters">
      {{ 'toolbar.filters' | translate }}
    </button>
  }
</mat-menu>
